import {combineReducers} from 'redux';
import user from './user.reducer';
import login from './login.reducer';
import register from './register.reducer';
import passwordreset from './passwordreset.reducer';
import passwordchange from './passwordchange.reducer';
import crud from './crud.reducer';

const authReducers = combineReducers({
    user,
    login,
    register,
    passwordreset,
    passwordchange,
    crud
});

export default authReducers;


// WEBPACK FOOTER //
// src/auth/store/reducers/index.js